const getAngle = (latLng1, latlng2, coef) => {
  const dy = latlng2[0] - latLng1[0];
  const dx = Math.cos((Math.PI / 180) * latLng1[0]) * (latlng2[1] - latLng1[1]);
  const ang = (Math.atan2(dy, dx) / Math.PI) * 180 * coef;

  return ang.toFixed(2);
};

const distanceTo = (p1, p2) => {
  const x = p2.x - p1.x;
  const y = p2.y - p1.y;

  return Math.sqrt(x * x + y * y);
};

function Point(x, y, round) {
  this.x = round ? Math.round(x) : x;
  this.y = round ? Math.round(y) : y;
}

const myMidPoint = (latlng1, latlng2, per, mapObj) => {
  if (!mapObj) throw new Error("map is not defined");

  let ratio;

  const p1 = mapObj.project(new L.LatLng(latlng1));
  const p2 = mapObj.project(new L.LatLng(latlng2));

  const halfDist = distanceTo(p1, p2) * per;

  if (halfDist === 0) return mapObj.unproject(p1);

  const dist = distanceTo(p1, p2);

  if (dist > halfDist) {
    ratio = (dist - halfDist) / dist;
    const res = mapObj.unproject(
      new Point(p2.x - ratio * (p2.x - p1.x), p2.y - ratio * (p2.y - p1.y))
    );
    return [res.lat, res.lng];
  }
};

const getArrows = (arrLatlngs, color, arrowCount, mapObj) => {
  if (
    typeof arrLatlngs === "undefined" ||
    arrLatlngs == null ||
    !arrLatlngs.length ||
    arrLatlngs.length < 2
  )
    return [];

  if (typeof arrowCount === "undefined" || arrowCount == null) arrowCount = 1;

  if (typeof color === "undefined" || color == null) color = "";
  else color = "color:" + color;

  const result = [];
  for (let i = 1; i < arrLatlngs.length; i++) {
    const icon = L.divIcon({
      className: "arrow-icon",
      bgPos: [5, 5],
      html:
        '<div style="' +
        color +
        ";transform: rotate(" +
        getAngle(arrLatlngs[i - 1], arrLatlngs[i], -1).toString() +
        'deg)">▶</div>',
    });
    for (let c = 1; c <= arrowCount; c++) {
      result.push(
        L.marker(
          myMidPoint(
            arrLatlngs[i],
            arrLatlngs[i - 1],
            c / (arrowCount + 1),
            mapObj
          ),
          { icon }
        )
      );
    }
  }
  return result;
};

const loadMarker = (
  marker,
  marker1,
  map,
  defaultLatitude,
  defaultLongitude,
  defaultLatitudeDestination,
  defaultLongitudeDestination,
  isPathEnabled
) => {
  const latlngs = [];
  // Get latlng from first marker
  latlngs.push(marker.getLatLng());
  // Get latlng from first marker
  latlngs.push(marker1.getLatLng());
  // You can just keep adding markers
  // From documentation http://leafletjs.com/reference.html#polyline
  // create a red polyline from an arrays of LatLng points
  const polyline = L.polyline(latlngs, { color: "red" });
  // eslint-disable-next-line new-cap
  const featureGroup = new L.featureGroup();
  marker.setLatLng(new L.LatLng(defaultLatitude, defaultLongitude), {
    draggable: "true",
  });
  marker1.setLatLng(
    new L.LatLng(defaultLatitudeDestination, defaultLongitudeDestination),
    { draggable: "true" }
  );
  featureGroup.addLayer(marker);
  featureGroup.addLayer(marker1);
  if (isPathEnabled) {
    featureGroup.addLayer(polyline);
  }
  featureGroup.addTo(map);
  map.fitBounds(featureGroup.getBounds());
  const mylatlngs = [
    [defaultLatitude, defaultLongitude],
    [defaultLatitudeDestination, defaultLongitudeDestination],
  ];
  if (isPathEnabled) {
    L.featureGroup(getArrows(mylatlngs, "red", 5, map)).addTo(map);
  }
};

const initMap = (
  mapId,
  defaultLatitude,
  defaultLongitude,
  defaultLatitudeDestination,
  defaultLongitudeDestination,
  isPathEnabled
) => {
  let mapObject;
  L.mapbox.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
  const myIcon = L.icon({
    iconUrl: "/build/images/marker-icon3.png",
    shadowUrl:
      "//api.tiles.mapbox.com/mapbox.js/v1.6.2/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    shadowAnchor: [12, 41],
  });

  if (defaultLatitude && !mapObject) {
    mapObject = L.mapbox
      .map(mapId)
      .setView([defaultLatitude, defaultLongitude], 5)
      .addLayer(L.mapbox.styleLayer(process.env.REACT_APP_MAPBOX_STYLE_ID));
  } else if (!mapObject) {
    mapObject = L.mapbox
      .map(mapId)
      .setView([countryLatitude, countryLongitude], 5)
      .addLayer(L.mapbox.styleLayer(process.env.REACT_APP_MAPBOX_STYLE_ID));
  }
  const marker = L.marker([defaultLatitude, defaultLongitude]);
  const marker1 = L.marker(
    [defaultLatitudeDestination, defaultLongitudeDestination],
    { icon: myIcon, draggable: false }
  );
  setTimeout(() => {
    mapObject.invalidateSize();
    loadMarker(
      marker,
      marker1,
      mapObject,
      defaultLatitude,
      defaultLongitude,
      defaultLatitudeDestination,
      defaultLongitudeDestination,
      isPathEnabled
    );
  });
};

export default initMap;
